<template>
  <Layout>
    <q-card class="flexbox">
      <div class="profile-header">
        <div class="profile-header-title">Companies</div>
        <div class="profile-header-icons">
          <q-btn color="red" round @click="isAddCompany=true">
            <q-icon color="white" name="fas fa-plus" size="15px" class="cursor-pointer"></q-icon>
          </q-btn>
        </div>
      </div>
      <div class="profile-content">
        <div class="q-pa-md" style="width:100%">
          <loading v-if="companies.length === 0 && loading"></loading>
          <empty-value
            description="If you want to add company please hit the button."
            name="company"
            v-if="companies.length === 0 && !loading"
          ></empty-value>
          <div v-else class="row q-col-gutter-md">
            <company
              v-for="(item, index) in companies"
              :index="index"
              :company="item"
              :key="item.id"
            ></company>
          </div>
        </div>
      </div>
      <company-add></company-add>
      <company-edit></company-edit>
      <confirm />
    </q-card>
  </Layout>
</template>

<script>
import axios from "../axios/index";
import Layout from "../components/Layout";
import CompanyAdd from "../components/CompanyAdd";
import Confirm from "../components/Confirm";
import CompanyEdit from "../components/CompanyEdit";
import Loading from "../components/Loading";
import EmptyValue from "../components/EmptyValue";
export default {
  metaInfo() {
    return {
      title: "Managing the owned Companies | FMS",
      // title: "FMS - Build your network in your field of interest",
      meta: [
        {
          name: "description",
          // "FMS is about connecting in your field of interest. Our vision is to help people share their knowledge, work, projects, papers and ideas and build their network through what they do rather where they live, study or work.",
          content:''
        },
        {
          property: "og:title",
          content: "Managing the owned Companies | FMS",
        },
        { property: "og:site_name", content: "FMS" },
        { property: "og:type", content: "website" },
        { name: "robots", content: "index,follow" },
      ],
    };
  },
  components: {
    Loading,
    EmptyValue,
    CompanyEdit,
    Confirm,
    Layout,
    CompanyAdd,
    Company: () => import("../components/Company")
  },
  async mounted() {
    const responses = await Promise.all([
      axios.get("companies"),
      axios.get("packages")
    ]);
    this.$store.commit("company/SET_USER_COMPANIES", responses[0].data.data);
    this.$store.commit("company/SET_COMPANY_PACKAGES", responses[1].data.data);
    this.loading = false;
  },
  computed: {
    confirm: {
      get() {
        return this.$store.state.company.confirm;
      },
      set(val) {
        this.$store.commit("company/SET_CONFIRM", val);
      }
    },
    edit: {
      get() {
        return this.$store.state.company.edit;
      },
      set(val) {
        this.$store.commit("company/SET_EDIT", val);
      }
    },
    isAddCompany: {
      get() {
        return this.$store.state.company.isAddCompany;
      },
      set(val) {
        this.$store.commit("company/SET_IS_ADD_COMPANY", val);
      }
    },
    companies: {
      get() {
        return this.$store.state.company.companies;
      },
      set(val) {
        this.$store.commit("company/SET_UPDATE_COMPANY", val);
      }
    },
    loading: {
      get() {
        return this.$store.state.company.loading;
      },
      set(val) {
        this.$store.commit("company/SET_LOADING", val);
      }
    }
  }
};
</script>
